var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177V2.5a.8.8 0 0 1-.593-.24.8.8 0 0 1-.24-.593q0-.354.24-.594t.593-.24h3.334q0-.354.24-.593Q4.645 0 5 0h3.333q.354 0 .594.24t.24.593H12.5q.354 0 .594.24t.24.594-.24.593a.8.8 0 0 1-.594.24v10.833q0 .688-.49 1.177-.489.49-1.177.49zm8.333-12.5H2.5v10.833h8.333zm-5.24 8.927q.24-.24.24-.594V5a.8.8 0 0 0-.24-.594.8.8 0 0 0-.593-.24.8.8 0 0 0-.594.24.8.8 0 0 0-.24.594v5.833q0 .354.24.594t.594.24.594-.24m3.334 0q.24-.24.24-.594V5a.8.8 0 0 0-.24-.594.8.8 0 0 0-.594-.24.8.8 0 0 0-.593.24A.8.8 0 0 0 7.5 5v5.833q0 .354.24.594t.593.24.594-.24",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.66bd3054961f8ac301858335eaf50a47.svg";
export { ForwardRef as ReactComponent };